var gbs = {
  //host: '/slsAdminApi', // 接口根地址。本地代理到slsadmin.api.sls.com,线上使用的是Nginx代理
  host: 'https://wenzhangdati.com/687/public/index.php/api/v1/',
  db_prefix: 'solely', // 本地存储的key
  // 状态码字段
  api_status_key_field: 'solely_code',
  // 状态码value
  api_status_value_field: 100000,
  // 存放数据的字段
  api_data_field: '',
  api_custom: {
    404: function(res) {
      this.$store.dispatch('remove_userinfo').then(() => {
        this.$alert(res.status + ',' + res.msg + '！', '登录错误', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/login')
          }
        })
      })
    }
  },
  tecncent_oss: {
    SecretId: '',
    SecretKey: '',
    Bucket: '',
    Region: 'ap-chengdu'
  },
  menu: [{
      id: '0',
      name: '控制面板',
      icon: 'el-icon-s-platform',
      router: '/home/dashboard',
      button: [],
      hasButton: [],
      isShow: true,
      parent: '0'
    },
    {
      id: '1',
      name: '设置管理',
      icon: 'el-icon-setting',
      isShow: true,
      children: [{
          id: '1-1',
          name: '管理员列表',
          router: '/home/adminLists',
          icon: 'reorder',
          isShow: true,
          button: ['编辑账号', '管理权限', '添加账号', '删除选中', '编辑信息'],
          hasButton: [],
          parent: '1'
        },
        {
          id: '1-2',
          name: '权限管理',
          router: '/home/access',
          icon: 'reorder',
          isShow: false,
          button: ['返回', '权限全选', '更新权限'],
          hasButton: [],
          parent: '1'
        },
        {
          id: '1-3',
          name: '项目配置',
          router: '/home/config',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '添加', '删除选中'],
          hasButton: [],
          parent: '1'
        },
        {
          id: '1-4',
          name: '平台信息',
          router: '/home/thirdApp',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '添加', '删除选中'],
          hasButton: [],
          parent: '1'
        },
        {
          id: '1-5',
          name: '角色管理',
          router: '/home/role',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '添加', '删除选中', '管理权限'],
          hasButton: [],
          parent: '1'
        }
      ]
    },
    {
      id: '2',
      name: '用户管理',
      icon: 'el-icon-user-solid',
      isShow: true,
      children: [{
        id: '2-1',
        name: '普通用户管理',
        router: '/home/user',
        icon: 'reorder',
        isShow: true,
        button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '添加流水'],
        hasButton: [],
        parent: '2'
      }]
    },

    {
      id: '3',
      name: '内容管理',
      icon: 'el-icon-s-unfold',
      isShow: true,
      children: [{
          id: '3-1',
          name: '文章菜单管理',
          router: '/home/label',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '3'
        },
        {
          id: '3-2',
          name: '轮播管理',
          router: '/home/banner',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '3'
        },
        {
          id: '3-3',
          name: '平台文章',
          router: '/home/article',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '3'
        },
        {
          id: '3-4',
          name: '公告管理',
          router: '/home/notice',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '3'
        },
      ]
    },

    {
      id: '4',
      name: '文章管理',
      icon: 'el-icon-chat-dot-square',
      isShow: true,
      children: [
        {
          id: '4-1',
          name: '文章类别',
          router: '/home/artLabel',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '4'
        },
        {
          id: '4-2',
          name: '文章管理',
          router: '/home/articleLists',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '4'
        },
      ]
    },

    {
      id: '5',
      name: '优惠券管理',
      icon: 'el-icon-s-ticket',
      isShow: true,
      children: [{
        id: '5-1',
        name: '优惠券列表',
        router: '/home/coupon',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '添加'],
        hasButton: [],
        parent: '5'
      }]
    },

    {
      id: '6',
      name: '平台商品管理',
      icon: 'el-icon-shopping-cart-full',
      isShow: true,
      children: [{
          id: '6-1',
          name: '商品类别',
          router: '/home/productLabel',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加', '添加下级'],
          hasButton: [],
          parent: '6'
        },
        {
          id: '6-2',
          name: '打赏商品',
          router: '/home/product',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '6'
        },
      ]
    },

    {
      id: '7',
      name: '商家管理',
      icon: 'el-icon-s-shop',
      isShow: true,
      children: [

        {
          id: '7-1',
          name: '商家类别',
          router: '/home/shopLabel',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中', '添加'],
          hasButton: [],
          parent: '7'
        },
        {
          id: '7-2',
          name: '入驻商家',
          router: '/home/shop',
          icon: 'reorder',
          isShow: true,
          button: ['添加', '删除选中', '编辑', '店长管理', '商家商品管理', '商品类别管理'],
          hasButton: [],
          parent: '7'
        }, {
          id: '7-3',
          name: '店长管理',
          router: '/home/shopper',
          icon: 'reorder',
          isShow: false,
          button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '返回'],
          hasButton: [],
          parent: '7'
        }, {
          id: '7-4',
          name: '店员管理',
          router: '/home/staff',
          icon: 'reorder',
          isShow: false,
          button: ['编辑账号', '添加账号', '删除选中', '编辑信息', '返回'],
          hasButton: [],
          parent: '7'
        },
        {
          id: '7-5',
          name: '商家商品管理',
          router: '/home/shopProduct',
          icon: 'reorder',
          isShow: false,
          button: ['编辑', '删除选中', '添加', '商品详情', '添加商品', '返回'],
          hasButton: [],
          parent: '7'
        },
        {
          id: '7-6',
          name: '商品类别管理',
          router: '/home/shopInnerLabel',
          icon: 'reorder',
          isShow: false,
          button: ['编辑', '删除选中', '添加', '返回'],
          hasButton: [],
          parent: '7'
        },
      ]
    },

    {
      id: '8',
      name: '订单管理',
      icon: 'el-icon-s-order',
      isShow: true,
      children: [{
        id: '8-1',
        name: '打赏订单',
        router: '/home/order',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '导出', '退款', '拒绝','通 过','拒 绝'],
        hasButton: [],
        parent: '8'
      }, {
        id: '8-2',
        name: '商城限时订单',
        router: '/home/xorder',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '导出', '退款', '拒绝'],
        hasButton: [],
        parent: '8'
      }, {
        id: '8-3',
        name: '商城团购订单',
        router: '/home/torder',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '导出', '退款', '拒绝'],
        hasButton: [],
        parent: '8'
      }, ]
    },

    {
      id: '9',
      name: '流水管理',
      icon: 'el-icon-s-finance',
      isShow: true,
      children: [{
          id: '9-1',
          name: '支付流水',
          router: '/home/pay',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中'],
          hasButton: [],
          parent: '9'
        },
        {
          id: '9-2',
          name: '余额流水',
          router: '/home/balance',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中'],
          hasButton: [],
          parent: '9'
        },
        {
          id: '9-3',
          name: '积分流水',
          router: '/home/score',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '删除选中'],
          hasButton: [],
          parent: '9'
        },
        {
          id: '9-4',
          name: '提现管理',
          router: '/home/withdraw',
          icon: 'reorder',
          isShow: true,
          button: ['同意', '拒绝', '导出'],
          hasButton: [],
          parent: '9'
        },

      ]
    },

    {
      id: '10',
      name: '详情管理',
      icon: 'el-icon-s-grid',
      isShow: false,
      children: [{
        id: '10-1',
        name: '商家商品详情',
        router: '/home/productpage',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '添加', '返回'],
        hasButton: [],
        parent: '10'
      }, {
        id: '10-2',
        name: '平台商品详情',
        router: '/home/productdetail',
        icon: 'reorder',
        isShow: true,
        button: ['编辑', '删除选中', '添加', '返回'],
        hasButton: [],
        parent: '10'
      }]
    },


    {
      id: '11',
      name: '数据备份',
      icon: 'el-icon-upload',
      isShow: true,
      children: [{
        id: '11-1',
        name: '数据备份',
        router: '/home/sql',
        icon: 'reorder',
        isShow: true,
        button: ['删除选中', '生成备份', '下载'],
        hasButton: [],
        parent: '11'
      }]
    },
    {
      id: '12',
      name: '操作记录',
      icon: 'el-icon-s-operation',
      isShow: true,
      children: [{
        id: '12-1',
        name: '操作记录',
        router: '/home/record',
        icon: 'reorder',
        isShow: true,
        button: ['删除选中'],
        hasButton: [],
        parent: '12'
      }]
    },
    {
      id: '13',
      name: '答题管理',
      icon: 'el-icon-s-operation',
      isShow: true,
      children: [
        {
          id: '13-1',
          name: '试卷管理',
          router: '/home/paper',
          icon: 'reorder',
          isShow: true,
          button: ['编辑', '生成试卷', '删除选中', '管理题目(试卷)'],
          hasButton: [],
          parent: '13'
        },
        {
          id: '13-2',
          name: '管理题目(试卷)',
          router: '/home/paperSubject',
          icon: 'reorder',
          isShow: false,
          button: ['编辑', '删除选中', '导入', '添加题目', '添加答案', '编辑答案', '删除答案', '返回','添加','重置试卷','设置'],
          hasButton: [],
          parent: '13'
        },
      ]
    },


  ]
}

var cbs = {
  /**
   * ajax请求成功，返回的状态码不是200时调用
   * @param  {object} err 返回的对象，包含错误码和错误信息
   */
  statusError(err) {
    console.log('err')
    if (err.status !== 404) {
      this.$message({
        showClose: true,
        message: '返回错误：' + err.msg,
        type: 'error'
      })
    } else {
      this.$store.dispatch('remove_userinfo').then(() => {
        this.$alert(err.status + ',' + err.msg + '！', '登录错误', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/login')
          }
        })
      })
    }
  },

  /**
   * ajax请求网络出错时调用
   */
  requestError(err) {
    this.$message({
      showClose: true,
      message: '请求错误：' + (err.response ? err.response.status : '') + ',' + (err.response ? err
        .response.statusText : ''),
      type: 'error'
    })
  }
}

export {
  gbs,
  cbs
}



// WEBPACK FOOTER //
// ./src/config/settings.js